var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-button',{attrs:{"to":{ name: 'InstitutionCreate' }}},[_vm._v(_vm._s(_vm.$t("InstitutionDetails.InstitutionCreate")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }